import React, { useState } from "react";
import { Box, Button, Card } from "@mui/material";
import { genderData, landSubUseTypes, landUseList, landUsesSchemeTypeList, siteInspRecommendation } from "../../citizen/TCPForms/data";
import {
  MainWrapper,
  PrimaryTabNewTheme,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTabNewTheme,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";

import DocumentSection from "../PurchasableFAR/DocumentSection";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import ActionButtons from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ActionButtons";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";

import Architect from "../../../../../templates/ApplicationDetails/RoleAccess/Architect";

import { BackButton } from "@egovernments/digit-ui-react-components";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import RecommendationRemarksComponent from "../RecommendationComponent";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";

import useLocalizedData from "../../../utils/hooks/useLocalizedData";
import useEmpLandUse from "../LandUseVerification&NOC/useEmpLandUse";
import SubStep1 from "../../citizen/AVPForms/formComponents/form-suggestion/SubStep1";
import SuggestionReviewTable from "./SuggestionReviewTable";
import HeaderContent from "../../citizen/AVPForms/components/Header";

const EmpFormSuggestionPortal = ({ formData, refetch, submitAction, workflowDetails, userRolesArray, isFromDashboard }) => {
  const specialCondition = formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible";
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("LU_CURRENT_TAB") || 0);
  const [subActiveTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("LU_CURRENT_SUBTAB") || 0);
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const isApproved = formData?.status === "APPROVED";
  // const {
  //   LANDUSE,
  //   ST_LABELS: subTabLabels,
  //   PT_LABELS: primaryTab,
  //   GENDER: genderList,
  //   SUBTYPE: landSubUses,
  //   LULIST: landUseListActivities,
  //   LUSCHEMELIST: landUsesSchemeList,
  // } = useLocalizedData({
  //   LANDUSE: SidebarLabelsLandUse,
  //   ST_LABELS: landUseSubTabLabels,
  //   PT_LABELS: primaryTabLabels,
  //   GENDER: genderData,
  //   SUBTYPE: landSubUseTypes,
  //   LULIST: landUseList,
  //   LUSCHEMELIST: landUsesSchemeTypeList,
  // });
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    handleChecklistNoWorkflow,
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);

  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("LU_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("LU_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab, formData = null) => {
    setSelectedDocSubTab(nextSubTab);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <SubStep1
            formData={params}
            isEmployee={!isCitizen}
            handleSubTabChange={handleSubTabChange}
            applicationFlow={department}
            isApproved={true}
          />
        );
      case 1:
        return <SuggestionReviewTable formData={params} onSelect={onSelect} />;
      case 2:
        return (
          <React.Fragment>
            <PrimaryContent
              formData={params}
              handleChange={handleChange}
              serviceName={"Inviting Suggestion/Objection"}
              avpLogo={avpLogo}
              daLogo={daLogo}
            />
            {!isApproved && (
              <CollapsibleHistory
                formData={params}
                callNotingDetailsAPI={callNotingDetailsAPI}
                developerRemarks={developerRemarks}
                setDeveloperRemarks={setDeveloperRemarks}
                notingRemarksData={notingRemarksData}
              />
            )}
            {/* {formData?.status === "APPLY_FOR_DSC" && (
            <DscLetters formData={formData} handleChange={handleTabChange} isEmployee={!isCitizen} viewDrawing={false} pdfType={"LA"} />
          )} */}

            {/* {!isApproved && (
            <Card style={{ color: "red" }}>
              <CheckBox handleChangeCheckBox={handleChangeCheckBox} declarationMessage={declarationMessage} checked={checked} />
              {checked === false && <p>Please review the NOC checklist and select the applicable items to complete the form verification.</p>}
            </Card>
          )} */}
            {!isApproved && <ActionButtons actions={actions} currentAction={currentAction} onSelect={onRadioActionSelect} />}
            {!isApproved && <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />}
            {!isApproved && <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />}
            {!isApproved && <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />}
          </React.Fragment>
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {/* <BackButton /> */}
      <MainWrapper className="main-panel-corner land-use-corner">
        {/* <HeaderContent applicationFlow={department} /> */}

        {!isCitizen && <EmpTopBar formData={formData} />}
        <Box sx={{ overflowY: "auto" }}>
          <PrimaryTabsWrapper>
            {/* Tabs Header */}
            <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
              <PrimaryTabNewTheme label="Application Data" />
              <PrimaryTabNewTheme label="Suggestion Review" />

              <PrimaryTabNewTheme label="Take Action" />
            </PrimaryTabs>
          </PrimaryTabsWrapper>

          <StyledDivider />

          {renderContent()}
        </Box>
      </MainWrapper>
    </React.Fragment>
  );
};

export default EmpFormSuggestionPortal;
